export default "__VITE_ASSET__e0e5d3dc__"